import { FC } from 'react';

import { InfiniteScrollPaginator } from 'react-activity-feed';

import styles from './ProfilePaginator.module.css';

export type Props = {
  containerRef: any;
};

export const ProfilePaginator: FC<Props> = (paginatorProps) => {
  const getScrollParent: any = () => {
    // Currently, if we unmount the Feeds application together with the parent that contains it
    // the app throws an error, as it tries to remove some listeners but the reference is already gone.
    // This workaround prevents this from happening by mocking an empty element when there isn't an actual
    // parent element available.
    if (paginatorProps.containerRef.current) {
      return paginatorProps.containerRef;
    }
    return { current: { removeEventListener: () => {} } };
  };
  return (
    <InfiniteScrollPaginator
      useWindow={false}
      threshold={10}
      {...paginatorProps}
      getScrollParent={getScrollParent}
    />
  );
};

export const Placeholder = () => {
  return (
    <div className={styles.feedsGetStartedPlaceholder}>
      <LoadingSpinner className={styles.getStartedLoading} size={30} />
      <span className={styles.feedsGetStartedPlaceholderInfo}>
        Waiting for activity
      </span>
    </div>
  );
};
